module.exports = __webpack_public_path__ + "img/elantra-19.72b34932.png";